export const MigrolTheme = {
  name: 'Migrol Theme',
  themeId: 'migrol',
  colors: {
    brand: {
      primary: {
        100: '#FF0000'
      },
      secondary: {
        100: '212529'
      },
      accent: {
        100: '#363636'
      }
    }
  },
  fonts: {
    families: {
      text: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      display: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      condensed: '"Gotham Narrow-Blackitalic", "Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      heading: '"Gotham Narrow-Blackitalic", "Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      subHeading: '"Gotham Narrow-Blackitalic", "Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      notes: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleText: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleHeading: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articlePrice: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif'
    },
    sizes: {
      heading: {
        tiny: '24px',
        xtiny: '28px',
        xsmall: '32px',
        modest: '36px',
        small: '40px',
        medium: '44px',
        large: '46px',
        xlarge: '48px',
        huge: '50px'
      },
      text: {
        tiny: '12px',
        xtiny: '14px',
        xsmall: '16px',
        modest: '18px',
        small: '20px',
        medium: '22px',
        large: '26px',
        xlarge: '30px',
        huge: '32px'
      }
    }
  }
};